<template>
  <div class="card">
    <div class="card-body">
      <div class="customize-calendar">
        <full-calendar :config="config" :events="calendarEvents" @event-selected="viewBirthday" />
      </div>
    </div>

    <div class="modal" id="dlgContacto">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <section>
              <div class="box-typical-inner">
                <h4>
                  <strong>CONTACTO</strong>
                  <button type="button" class="close" @click="closeBirthday()">&times;</button>
                </h4>

                <hr class="mt-2 mb-3" />
                <h6>
                  <strong>EMPRESA</strong>
                  {{customer_name}}
                </h6>
                <hr class="mt-2 mb-3" />

                <p class="line-with-icon" v-if="contact.name">
                  <i class="fa fa-user"></i>&nbsp;
                  <strong>Nombre:</strong>
                  {{contact.name}} {{contact.last_name }}
                </p>

                <p class="line-with-icon" v-if="contact.occupation">
                  <i class="fa fa-sitemap"></i>&nbsp;
                  <strong>Cargo:</strong>
                  {{contact.occupation}}
                </p>

                <p class="line-with-icon" v-if="contact.mail">
                  <i class="fa fa-envelope"></i>&nbsp;
                  <strong>Correo:</strong>
                  <a href="#">{{contact.mail}}</a>
                </p>

                <p class="line-with-icon" v-if="contact.phone_number">
                  <i class="fa fa-phone"></i>&nbsp;
                  <strong>Teléfono:</strong>
                  +{{contact.phone_zone}} {{contact.phone_area}} {{contact.phone_number}}
                </p>

                <p class="line-with-icon" v-if="contact.mobile_number">
                  <i class="fa fa-phone"></i>&nbsp;
                  <strong>Celular:</strong>
                  +{{contact.mobile_zone}} {{contact.mobile_area}} {{contact.mobile_number}}
                </p>

                <p class="line-with-icon" v-if="contact.birthday_date">
                  <i class="fa fa-birthday-cake"></i>&nbsp;
                  <strong>Cumpleaños:</strong>
                  {{contact.birthday_date}}
                </p>

                <hr class="mt-2 mb-3" />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "fullcalendar/dist/locale/es";
export default {
  name: "Birthday",
  props: {
    caption: {
      type: String,
      default: "Cumpleaños"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      contact: {},
      customer_name: null,
      config: {
        locale: "es",
        defaultView: "month",
        editable: false,
        timeFormat: "hh:mm a"
      },
      calendarEvents: []
    };
  },
  mounted() {
    this.getBirthday();
  },
  methods: {
    getBirthday() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      var staff_id = auth[0].staff_id;

      this.$http
        .get(
          `${this.$urlApi}contacts/birthday/staff/${staff_id}?token=${this.token}`
        )
        .then(
          function(response) {
            this.calendarEvents = response.data.data;
            console.log(response.data.data);
            hideLoader();
          },
          error => {
            console.log(error);
            hideLoader();
          }
        );
    },
    closeBirthday() {
      this.taskSelected = {};
      $("#dlgContacto").modal("hide");
    },
    viewBirthday(event) {
      $("#dlgContacto").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL

      this.contact = {
        id: event.id,
        name: event.name,
        last_name: event.last_name,
        occupation: event.occupation,
        mail: event.mail,
        phone_number: event.phone_number,
        phone_zone: event.phone_zone,
        phone_area: event.phone_area,
        mobile_number: event.mobile_number,
        mobile_zone: event.mobile_zone,
        mobile_area: event.mobile_area,
        birthday_date: event.birthday_date
      };
      this.customer_name = event.customer_name;

      $("#dlgContacto").modal("show");
    },
    viewCustomer() {
      $("#dlgContacto").modal("hide");
      // this.$router.push({path: `../../customers/view/${this.taskSelected.customer_id.toString()}`})
    }
  }
};
</script>